import { Box, Typography } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipNFSeStatus = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                <Typography variant="body1">
                    A emissão da nota fiscal é feita pela prefeitura. 
                    O Produttivo apenas exibe o status retornado, que pode ser atualizado automaticamente conforme a comunicação entre os sistemas.
                </Typography>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipNFSeStatus;